module.exports = __webpack_public_path__ + "img/Bob.6b6bbefa.jpg";